import { z } from 'zod';
import { geoPointSchema } from './geoPointSchema';

export const addressDetailStateSchema = z.object({
  address: z.string().optional(),
  geoCode: geoPointSchema,
  postCode: z.string().optional(),
  countryCode: z.string().optional(),
  country: z.string().optional(),
});

export type AddressDetailState = z.infer<typeof addressDetailStateSchema>;
